import React, {useCallback, useEffect, useState} from 'react';
import {withStyles} from '@jpmuitk/theme';
import {ColumnLayout} from '@jpmuitk/column-layout';
import {Logo} from '@jpmuitk/logo';
import {getClientLogo} from "../redux/clientActions";
import {useParams} from "react-router-dom";
import { CircularProgress } from '@jpmuitk/progress';

const styles = {
  rootBox: {
    display: 'flex',
    alignItems: 'center',
    background: '#ffffff',
  },
  banner: {
    paddingLeft: '16px',
    height: '44px',
    background: '#ffffff',
    maxWidth: '1600px',
  },
  header: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: '#161616',
    paddingTop: '5px',
  },
  tabs: {
    paddingRight: 0,
  },
  tab: {
    paddingTop: '1rem',
  },
  tabIcon: {
    marginRight: '0.5rem',
  },
};

const Banner = ({classes, profileConfiguration, accessToken, sessionToken}) => {

  const defaultBannerColor = '#936946';

  const [fileWrapper, setFileWrapper] = useState()
  const [clientBannerColor, setClientBannerColor] = useState("#FFF")
  const [useDefaultBranding, setUseDefaultBranding] = useState(false)
  const {clientId, programId, profileName} = useParams()
  const [isLoading, setIsLoading] = useState(true);

useEffect(() => {
  const fetchClientLogo = async () => {
    setIsLoading(true);
    try {
      const response = await getClientLogo(accessToken, sessionToken);
      const fileWrapper = await response.json();
      if (fileWrapper.resource.length < 1) {
        setUseDefaultBranding(true);
        setClientBannerColor(defaultBannerColor);
      } else {
        setFileWrapper(fileWrapper);
        setClientBannerColor(profileConfiguration ? profileConfiguration.primaryColor : defaultBannerColor);
        setUseDefaultBranding(false);
      }
    } catch (error) {
      console.log("Got error rendering logo: ", error);
      setUseDefaultBranding(true);
      setClientBannerColor(defaultBannerColor);
    } finally {
      setIsLoading(false);
    }
  };

  fetchClientLogo();
}, [clientId, programId, profileName, profileConfiguration]);

  return (
    <header style={{
      width: '100%',
      borderBottom: '3px solid' + (useDefaultBranding ? defaultBannerColor : clientBannerColor),
    }}>
      <ColumnLayout
        spacing={2}
        display="flex"
        alignContent="center"
        container
        justify="space-between"
      >
        <ColumnLayout item style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
          {isLoading ?
            <CircularProgress aria-label="Loading logo" showInfo={false} variant="indeterminate" size={'small'}
                              style={{ marginLeft: '10px' }} />
            : <ClientLogo useDefaultBranding={useDefaultBranding} fileWrapper={fileWrapper} />}
        </ColumnLayout>
      </ColumnLayout>
    </header>
  );
};

const ClientLogo = ({useDefaultBranding, fileWrapper}) => {
  const renderDefaultLogo = useCallback(() => <Logo density={'low'}/>, [])

  const renderClientLogo = useCallback(() => {
    if (fileWrapper) {
      let source = "data:"
      source += fileWrapper.contentType
      source += ";base64,"
      source += fileWrapper.resource
      return  <div
        style={{
          width: '120px',
          height: '30px',
          padding: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        }}>
        <img style={{
          objectFit: 'contain', maxWidth: '100%', maxHeight: '100%',
        }} src={source} alt={'BrandLogo'} />
      </div>
    } else {
      renderDefaultLogo()
    }
  }, [fileWrapper])

  return (
    <>
      {useDefaultBranding && renderDefaultLogo()}
      {!useDefaultBranding && renderClientLogo()}
    </>
  )
}

export default withStyles(styles)(Banner);

